import { transparentize } from 'polished';
import styled, { createGlobalStyle } from 'styled-components/macro';
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from './app/constants';

const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: middle;
}
button{
  border: 0;
  background: transparent;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	//content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}

html{
  font-family: 'Open Sans', sans-serif;
  font-size:10px;
  height:100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

html body{
  font-family: 'Open Sans', sans-serif;
}
.mh-100{
  max-height: 100% !important;
}
a{ text-decoration: none }
.link{
  color: ${props => props.theme.accent};
  text-decoration: none;
  cursor: pointer;
  &:focus,
  &:hover{
    color:${props => props.theme.accent};
    text-decoration: none;
  }
}
.lbl{
  color:${props => props.theme.grey.primary};
  font-size: 1.2rem;
  font-weight: 600;
}
.txt{
  font-size: 1.4rem;
  font-weight: 400;
  color: ${props => props.theme.fontColor.primary};
  &-accent{
    color:${props => props.theme.accent}!important;
  }
  &-secondary{
    color:${props => props.theme.grey.primary}!important;
  }
  &.accent-hover{
    &:hover,
    &:focus{
      color:${props => props.theme.accent};
    }
  }
}

.tooltip-inner{
  font-size: 14px;
  padding: 5px 10px;
}

.live-news-time {
      color: ${props => props.theme.fontColor.primary};
      font-size: 1.6rem;
      font-weight: 700;
    }
    .live-news-event {
      font-size: 1.2rem;
      font-weight: 400;
      color: ${props => props.theme.fontColor.primary};
      line-height: 1.4;
    }
    .live-news-time-lbl {
      margin-bottom: 1.6rem;
    }
    .live-news-time-lbl,
    .live-news-event-lbl {
      color: ${props => props.theme.grey.primary};
      font-size: 1.2rem;
      font-weight: 600;
    }

.infinite-scroll-component{
  overflow: visible !important;
}

.overflow{
  &-y{
    &-auto{
      overflow-y: auto!important;
    }
  }
}

${Array.from(Array(100), (_, i) => i)
  .map(
    i => `.mr-${i}{
    	margin-right:${i}px!important;
  	}`
  )
  .join(' ')}

${Array.from(Array(100), (_, i) => i)
  .map(
    i => `.mb-${i}{
    	margin-bottom:${i}px!important;
  	}`
  )
  .join(' ')}

${Array.from(Array(100), (_, i) => i)
  .map(
    i => `.mt-${i}{
    	margin-top:${i}px!important;
  	}`
  )
  .join(' ')}

${Array.from(Array(100), (_, i) => i)
  .map(
    i => `.fs-${i}{
		font-size:${i / 10}rem!important;
  	}`
  )
  .join(' ')}

${Array.from(Array(9), (_, i) => i)
  .map(
    i => `.fw-${i}{
		font-weight:${i * 100}!important;
  	}`
  )
  .join(' ')}

.tablet-hidden{
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: none!important;
  }
}
.mobile-hidden{
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: none!important;
  }
}
.tablet-visible{
  display: none !important;
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: block!important;
  }
}
th.mobile-visible, td.mobile-visible{
  display: none !important;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: table-cell!important;
  }
}
.mobile-visible{
  display: none !important;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: block!important;
  }
}
// .horse-detailed {
//   @media (max-width: ${TABLET_BREAKPOINT}px) {
//     padding: 0 !important;
//   }
// }
.nav.nav-tabs {
    border-bottom: 0;
    .nav-item {
      &:first-child {
        margin-left: 2.8rem;
      }
      &:last-child {
        margin-right: 2.8rem;
      }
    }
    .nav-link {
      font-size: 1.6rem;
      font-weight: 800;
      color: ${props => props.theme.fontColor.primary};
      line-height: 2.1rem;
      border: 0;
      padding: 2rem 1.6rem;
      &.active {
        color: ${props => props.theme.accent};
        border-bottom: 3px solid ${props => props.theme.accent};
      }
    }
  }
  .table.sticky-head thead{
    position: sticky;
    top:0;
  }

  .table{
  border-collapse: separate;
  border-spacing: 0;
  thead{
    tr{
      &:first-child{
        th{
          &:first-child{
            border-top-left-radius:1rem;
            border-left:1px solid ${props => props.theme.grey.light};
            @media (max-width: ${TABLET_BREAKPOINT}px) {
              border-left:0 !important;
              border-radius: 0;
            }
          }
          &:last-child{
            border-top-right-radius:1rem;
            border-right:1px solid ${props => props.theme.grey.light};
            @media (max-width: ${TABLET_BREAKPOINT}px) {
              border-right:0 !important;
              border-radius: 0;
            }
          }
        }
      }
      th{
        @media (max-width: ${TABLET_BREAKPOINT}px) {
          padding: 1.5rem 1rem;
          border-top: 0;
        }
        font-size: 1rem;
        font-weight: 700;
        color: ${props => props.theme.grey.primary};
        background-color: ${props => props.theme.grey.light2};
        border-top: 1px solid ${props => props.theme.grey.light};
        border-bottom: 1px solid ${props => props.theme.grey.light};
        vertical-align: middle;
        padding: 1rem 0.7rem !important;
      }
    }
  }
  tbody{
    tr{
      td{
        vertical-align: middle;
        padding: 2rem 1rem;
        border-bottom:1px solid ${props => props.theme.grey.light};
        font-size: 1.2rem;
        &:first-child{
          border-left: 1px solid ${props => props.theme.grey.light};
        }
        &:last-child{
          border-right: 1px solid ${props => props.theme.grey.light};
        }
        @media (max-width: ${TABLET_BREAKPOINT}px) {
          padding: 0.7rem;
        }
      }
      &:last-child{
        td{
          &:first-child{
            border-bottom-left-radius:1rem;
          }
          &:last-child{
            border-bottom-right-radius:1rem;
          }
        }
      }
    }
  }
}
.table>:not(:last-child)>:last-child>*{
  border-bottom-color: ${props => props.theme.grey.light};
}
.table-decorated-cell{
  display: flex;
  align-items: center;
  justify-content: center;
  div + div{
    margin-left:1.4rem;
    padding-left:1.4rem;
    border-left:1px solid ${props => props.theme.grey.light};
  }
}
.dynamic{
  transition: 0.2s;
}
.txt-right{
  text-align: right;
}
@media (max-width: ${TABLET_BREAKPOINT}px) {
  #root, .container, html, body{
    height: auto !important;
  }
  html, body{
    overflow: auto;
  }
}

.table th:empty, .table td:empty{
  padding: 0 !important;
}

`;

export const StyledEventImage = styled.div`
  overflow: hidden;
  img {
    width: 87px;
    height: 46px;
    object-fit: cover;
  }
`;

export const StyledCard = styled.div`
  border: 0;
  transition: 0.2s;
  border-radius: 1rem;
  .card-body {
    border-radius: 1rem;
  }
  &.active {
    .card-body {
      border-color: ${props => props.theme.accent};
    }
    box-shadow: 0 0.5rem 2rem 0
      ${props => transparentize(0.88, props.theme.fontColor.primary)};
  }
  .card-body {
    border: 1px solid ${props => props.theme.grey.light};
    border-radius: 1rem;
    padding: 1.8rem 1.6rem;
  }
  .card-footer {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.5rem 1.5rem 1.5rem;
    border: 1px solid ${props => props.theme.grey.light};
    border-bottom-left-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
    margin-top: -0.5rem;
    border-top: 0;
    .link {
      font-size: 1.4rem;
      font-weight: 700;
    }
  }
  &.card-vertical {
    width: 6.2rem;
    height: 26rem;
    .card-body {
      position: relative;
      width: 6.2rem;
      height: 26rem;
      .txt {
        transform-origin: 0 0;
        transform: rotate(-90deg) translate(-50%, -50%);
        position: absolute;
        left: 50%;
        top: 50%;
        width: 22rem;
        text-align: center;
      }
    }
  }
`;

export default GlobalStyle;
